import type { FormatterUnit } from "~/tools/formatter-unit";

import { DEFAULT as DEFAULT_LEGEND, type Settings as LegendSettings } from "../legend/settings";
import type { Mode as ThresholdsMode, Step as ThresholdsStep } from "../thresholds/settings";

interface Settings {
	unit?: string;
	decimals?: number;
	min?: number;
	max?: number;

	yAxis?: {
		show?: boolean;
		label?: string;
	};

	legend?: LegendSettings;

	thresholds?: {
		mode?: ThresholdsMode;
		steps?: ReadonlyArray<ThresholdsStep>;
	};
}

const DEFAULT = {
	unit: "short" satisfies FormatterUnit,
	decimals: undefined,
	min: undefined,
	max: undefined,
	yAxis: {
		show: true,
		label: undefined,
	},
	legend: DEFAULT_LEGEND,
	thresholds: {
		mode: "absolute",
		steps: [],
	},
} as const satisfies Settings;

export { DEFAULT };
export type { Settings };
